import { CustomToast } from "../views/CustomToast";
import React, { useState, useEffect } from 'react';

// Custom Toast Hook
export const useToast = () => {
    const [toasts, setToasts] = useState([]);
  
    const showToast = (message, type = 'info', duration = 5000) => {
      const id = Date.now() + Math.random();
      const newToast = { id, message, type };
      
      setToasts(prev => [...prev, newToast]);
  
      // Auto remove after duration
      setTimeout(() => {
        removeToast(id);
      }, duration);
    };
  
    const removeToast = (id) => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    };
  
    const toast = {
      success: (message, duration) => showToast(message, 'success', duration),
      error: (message, duration) => showToast(message, 'error', duration),
      warning: (message, duration) => showToast(message, 'warning', duration),
      info: (message, duration) => showToast(message, 'info', duration),
    };
  
    const ToastContainer = () => (
      <div>
        {toasts.map((toast, index) => (
          <div
            key={toast.id}
            style={{
              position: 'fixed',
              top: `${20 + index * 80}px`,
              right: '20px',
              zIndex: 9999,
            }}
          >
            <CustomToast
              message={toast.message}
              type={toast.type}
              onClose={() => removeToast(toast.id)}
            />
          </div>
        ))}
      </div>
    );
  
    return { toast, ToastContainer };
  };